// 关于银行服务的接口
import http from "@/promise/http"
const CONTROLLER_NAME = "/bankCode/";

// 根据银行卡号前6位查询银行名称
export const postSelectBankNameByBankCode = bankCode => {
    return http.post(
        CONTROLLER_NAME.concat("selectBankNameByBankCode"),
        bankCode
    );
};